import euroIcon from 'assets/icon/euro-icon.svg'
import bitcoinIcon from 'assets/icon/bitcoin-icon.svg'
import ethereumIcon from 'assets/icon/ethereum-icon.svg'
import tetherIcon from 'assets/icon/tether-icon.svg'

export const myWalletCurrencies = [
  {
    value: 'EUR',
    label: '€',
    icon: euroIcon,
  },
  {
    value: 'BTC',
    label: '₿',
    icon: bitcoinIcon,
  },
  {
    value: 'ETH',
    label: 'Ξ',
    icon: ethereumIcon,
  },
  {
    value: 'Tether',
    label: 'USDT',
    icon: tetherIcon,
  },
]

export const statisticIntervals = ['Week', 'Month', 'Year']

export const statisticBreakdowns = {
  Week: 'daily',
  Month: 'monthly',
  Year: 'yearly',
}

export const calendarEventTypes = [
  {
    name: 'Approved',
    color: '#1AC057',
  },
  {
    name: 'Waiting for approval',
    color: '#338AF3',
  },
]

export const calendarTooltips = {
  tutor:
    'If you do not accept or decline this class within 24 hours, it will be declined automatically.\n\nNote: You cannot decline more than 30% of your weekly classes (maximum limit of 5 classes).',
  student:
    'Awaiting tutor response. In the case of a class being declined, your payment will be refunded.',
}

export const upcomingClassesSortOptions = [
  {
    id: 'closest',
    value: 'Closest Date',
  },
  {
    id: 'furthest',
    value: 'Furthest Date',
  },
  {
    id: 'a_z',
    value: 'Name A-Z',
  },
  {
    id: 'z_a',
    value: 'Name Z-A',
  },
]

export const upcomingClassesFilterGenders = [
  {
    value: '_',
    label: 'Any gender',
  },
  {
    value: 'male',
    label: 'Male',
  },
  {
    value: 'female',
    label: 'Female',
  },
]

export const tradingMarketFavorites = ['BTC', 'KCS', 'USDT', 'ALTS']

export const tradingMarketTableHeadings = [
  'Pairs',
  'Coin',
  'Last Price',
  'Change (24H)',
  'High (24H)',
  'Low (24h)',
  'Volume (24h)',
]

export const tradingAssetsTableHeadings = [
  'Balance',
  'Coin',
  'Last Price',
  'Change (24H)',
  'High (24H)',
  'Low (24h)',
  'Volume (24h)',
]

export const tradingMarketTableRows = [
  {
    id: 1,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 2,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '-1.65%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 3,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 4,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 5,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 6,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 7,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 8,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 9,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 10,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 11,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 12,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 13,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 14,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 15,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 16,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 17,
    pairs: 'ETH/BTC',
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
]

export const tradingAssetsTableRows = [
  {
    id: 1,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 2,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '-1.65%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 3,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 4,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 5,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 6,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 7,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 8,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 9,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 10,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 11,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 12,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 13,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 14,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 15,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 16,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
  {
    id: 17,
    balance: 5420.15,
    coin: 'ETH',
    coinIcon: '/assets/icon/eth.png',
    lastPrice: 7394.06,
    change: '+0.78%',
    high: 7444.91,
    low: 7267.06,
    volume: '431,687,258.77',
  },
]

export const marketTradeTabs = ['Limit', 'Market', 'Stop Limit', 'Stop Market']

export const marketTradePercentages = [25, 50, 75, 100]

export const topCategoryColors = ['#3FC0FF', '#AF3DC6', '#F04646']

export const orderTabs = ['Open Orders', 'Closed Orders', 'Order history', 'Balance']

export const orderHeadings = [
  'Time',
  'All pairs',
  'All Types',
  'Buy/Sell',
  'Price',
  'Amount',
  'Executed',
  'Unexecuted',
]

export const tutorMapColors = ['blue', 'orange', 'purple', 'pink', 'green']

export const tutorStatsDatasets = [
  {
    key: 'classes_finished',
    color: '#FB9157',
    label: 'Classes Completed',
  },
  {
    key: 'quiz_completed',
    color: '#3FC0FF',
    label: 'Quizzes Completed',
  },
  {
    key: 'reviews_given',
    color: '#AF3DC6',
    label: 'Awards Achieved',
  },
]

export const studentStatsDatasets = [
  {
    key: 'bookings_count',
    color: '#FB9157',
    label: 'Classes Completed',
  },
  {
    key: 'quiz_completed',
    color: '#3FC0FF',
    label: 'Quizzes Completed',
  },
]

export const classStatuses = {
  approved: {
    background: 'bg-[#1AC057]',
    title: 'Accepted Class',
  },
  in_review: {
    background: 'bg-[#338AF3]',
    title: 'In Review',
  },
  cancelled: {
    background: 'bg-[#EF4343]',
    title: 'Cancelled',
  },
}
